export const SET_AVAILABILITY = "SET_AVAILABILITY"
export const SET_ROOMS = "SET_ROOMS"
export const CLEAR_AVAILABILITY = "CLEAR_AVAILABILITY"
export const SET_OBJECTS = "SET_OBJECTS"
export const SET_OBJECT_ID_BUSY = "SET_OBJECT_ID_BUSY"
export const SET_ROOM_ID = "SET_ROOM_ID"